import script from "./toastNotify.vue?vue&type=script&setup=true&lang=js"
export * from "./toastNotify.vue?vue&type=script&setup=true&lang=js"

import "./toastNotify.vue?vue&type=style&index=0&id=b609554c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b609554c"]])

export default __exports__